export default __webpack_public_path__ + "2d26d04b4fcfe53c007207636e90899e.png";